// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606151533/js/" + chunkId + "." + {"44":"56d8d32f","225":"77f862df","481":"a8af2cc8","486":"a153b427","770":"2149e806"}[chunkId] + ".0.20894084083820197.chunk.js";
};